module.exports = __webpack_public_path__ + "static/media/locker.98bc50c3.svg";